import React from 'react'
import { Typography, makeStyles, Button, Grid} from '@material-ui/core'
import {Link} from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems:'center',
        [theme.breakpoints.down('sm')]:{
            
            marginTop:'30px'
        }
        // backgroundColor:'red'
    },
    sectionHeading: {
        fontSize: '64px',
        fontWeight: 600,
        letterSpacing: 0.1,
        margin: '0 20px',
        lineHeight: '60px',
        [theme.breakpoints.down('md')]:{
            fontSize: '54px',
        },
        [theme.breakpoints.down('sm')]:{
            fontSize: '45px',
            lineHeight: '40px',
            marginTop:'30px'
        }
    },
    note1:{
        margin: '15px 10px 10px 20px',
        fontWeight:600
    },
    note2:{
        color: theme.palette.secondary.dark,
        marginLeft: '20px',
        fontSize: '24px',
        fontWeight:'500'
    },
    authorDesc:{
        width: '90%',
        maxWidth: '600px',
        [theme.breakpoints.down('sm')]:{
            textAlign:'center'
        }
    },
    exploreBtn:{
        color: 'black',
        marginLeft: '20px',
        boxShadow: 'none',
        borderRadius: 2,
        padding: '10px 75px',
        margin: '20px 0',
        '&:hover':{
            color: theme.palette.secondary.light
        }
    }
}))

function AuthorSubmissions() {
    const classes = useStyles()
    return (
        <div className={classes.root}>
            <Grid container style={{width: '100%'}} spacing={0} alignItems= 'center'>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <img src="./assets/images/authorSub.png" alt="auth_sub" style={{width: '100%'}} />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <div className={classes.authorDesc}>
                        <h2 className={classes.sectionHeading}>Author Submissions</h2>
                        <Typography variant="body1" color="error" className={classes.note1}>Must have PayPal account to use our services.</Typography>
                        <p style={{marginLeft:'20px'}}>If you would like to distribute your original work through our platform, please provide a brief description of your project, as well as a short bio of yourself, and your email address.</p>
                        <Typography className={classes.note2}><i>Please allow up to seven days for processinhg</i></Typography>
                        <Link to="/shop" style={{textDecoration:'none'}}>
                            <Button color="primary" variant="contained" className={classes.exploreBtn} >EXPLORE</Button>
                        </Link>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default AuthorSubmissions
